import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type TenantUsage } from '../../api/saas';

export function TenantAnalyticsPage() {
  const [usage, setUsage] = useState<TenantUsage[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void saasApi.tenantUsage().then(setUsage).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Tenant Analytics</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-4 overflow-x-auto rounded-lg border dark:border-slate-700">
        <table className="w-full text-left text-sm">
          <thead className="border-b bg-slate-50 dark:border-slate-700 dark:bg-slate-800">
            <tr>
              <th className="px-4 py-2">Tenant</th>
              <th className="px-4 py-2">Users</th>
              <th className="px-4 py-2">Modules</th>
              <th className="px-4 py-2">Storage GB</th>
              <th className="px-4 py-2">AI Credits</th>
              <th className="px-4 py-2">API Calls</th>
            </tr>
          </thead>
          <tbody>
            {usage.map((u) => (
              <tr key={u.tenant_id} className="border-b dark:border-slate-800">
                <td className="px-4 py-2 font-mono text-xs">{u.tenant_id.slice(0, 8)}…</td>
                <td className="px-4 py-2">{u.active_users}</td>
                <td className="px-4 py-2">{u.module_count}</td>
                <td className="px-4 py-2">{u.storage_used_gb.toFixed(1)}</td>
                <td className="px-4 py-2">{u.ai_used_credits.toFixed(0)}</td>
                <td className="px-4 py-2">{u.api_calls.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
